import { useQuery, type UseQueryResult } from '@tanstack/react-query'

import { downloadBlob } from 'src/app/core/adapters/download-blob.adapter'
import { memberInsightsKeys } from 'src/app/home/queries/member-insights-keys'

export interface IUseMemberInsightDownloadQueryParams {
  downloadUrl: string
  enabled: boolean
}

export const useMemberInsightDownloadQuery = (
  params: IUseMemberInsightDownloadQueryParams,
): UseQueryResult<Blob, Error> => {
  return useQuery({
    queryKey: memberInsightsKeys.download(params.downloadUrl),
    queryFn: () => downloadBlob(params.downloadUrl),
    enabled: params.enabled,
    staleTime: Infinity,
    gcTime: 5 * 60 * 1000,
  })
}
